const TENCENT_CAPTCHA_URL = 'https://turing.captcha.qcloud.com/TJCaptcha.js';
const TENCENT_CAPTCHA_APP_ID = '2050970272';
let loadScriptPromise = null;
function getCaptchaConstructor() {
    return window.TencentCaptcha || window.TJCaptcha || null;
}
function loadTencentCaptchaScript() {
    if (getCaptchaConstructor()) {
        return Promise.resolve();
    }
    if (loadScriptPromise) {
        return loadScriptPromise;
    }
    loadScriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = TENCENT_CAPTCHA_URL;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('验证码脚本加载失败'));
        document.head.appendChild(script);
    });
    return loadScriptPromise;
}
function openTencentCaptcha() {
    return new Promise((resolve, reject) => {
        const Captcha = getCaptchaConstructor();
        if (!Captcha) {
            reject(new Error('验证码组件不可用'));
            return;
        }
        const callback = (res) => {
            if (res && res.ret === 0 && res.ticket && res.randstr) {
                resolve({
                    ticket: res.ticket,
                    randstr: res.randstr,
                });
                return;
            }
            reject(new Error('验证码校验未通过'));
        };
        try {
            const captcha = new Captcha(TENCENT_CAPTCHA_APP_ID, callback);
            if (captcha && typeof captcha.show === 'function') {
                captcha.show();
                return;
            }
        } catch (e) {
            // ignore and fallback
        }
        try {
            Captcha(TENCENT_CAPTCHA_APP_ID, callback);
        } catch (e) {
            reject(new Error('验证码初始化失败'));
        }
    });
}
export async function getTencentCaptchaResult() {
    await loadTencentCaptchaScript();
    return openTencentCaptcha();
}
